import { Store } from '@ngxs/store';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { BdGraph, BdGraphNode } from 'src/lib/graph/graph.model';
import { BdGraphService } from 'src/lib/graph/graph.service';

export namespace SelectedObjectUtils {

  interface SelectedNodesDict {
    [objectId: string]: true;
  }

  export function selectedNodesAsDict(store: Store): SelectedNodesDict {
    return store
      .selectSnapshot(EngineNodesState.getCheckedNodeIds)
      .reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});
  }

  // EngineNodeState isn't the definitive source of truth of selected objects.
  // If a successor node is checked, it's leaves won't be.
  // We must check its leaves manually.
  export function isObjectSelected(
    objectId: string, 
    selectedNodes: SelectedNodesDict, 
    viewGraph: BdGraph<BdGraphNode>, 
    graphService: BdGraphService) {
    
    // If an object is in the store of checked nodes, great!
    if (selectedNodes[objectId]) {
      return true;
    }

    // If not, check to see if the object is one of its leaves!
    const selectedIds = Object.keys(selectedNodes);
    for (const id of selectedIds) {
      if (graphService.getLeafDescendants(viewGraph, id).includes(objectId)) {
        return true;
      }
    }

    return false;
  }
}
